/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';
import { colors } from 'styles/variables';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';

const { lGrey0 } = colors;
const maxWidth = 512;

const Feedback = props => {
  const { useMediaInFeedback = true, onClose, children } = props;
  const [image, text, btn] = children;

  //
  return (
    <Modal onClose={() => onClose()}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        {useMediaInFeedback && (
          <div
            css={css`
            width: 75%;
            margin-bottom: 30px;

            img {
              max-height: 30vh !important;
            }

            @media (max-width: 768px) {
              width: 100%;
              margin-bottom: 25px;
            }
          `}
          >
            {image}
          </div>
        )}
        <div
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {text}
        </div>
        <div
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            width: 100%;
          `}
        >
          {window.dev() ? btn : React.cloneElement(btn, { onClick: onClose })}
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
